export default __webpack_public_path__ + "static/media/pmc.2bba8168.jpg";